// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-groups {
  display: flex;
  flex-flow: row wrap;
  column-gap: 40px;
  row-gap: 28px;
  align-items: flex-start;
  margin-top: 20px;
}

.setting-group {
  flex: 1 1 280px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.setting-group-label {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.7;
}

.setting {
  display: flex;
  align-items: center;
}

.override-toggle {
  flex: 0 0 32px;
}

.form-fields {
  width: 90%;
  margin-top: 0px;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: -5px;
}`, "",{"version":3,"sources":["webpack://./src/app/organizations/org-default-user-settings/org-default-user-settings.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EAGA,aAAA;EACA,uBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,eAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EAGA,QAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;AAHJ;;AAMA;EAGI,cAAA;AALJ;;AAQA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AALJ","sourcesContent":[".setting-groups {\n    display: flex;\n    flex-flow: row wrap;\n    column-gap: 40px;\n    // Groups sit farther apart from each other than their rows do from one another (below),\n    // so proximity alone signals \"these settings belong together, that group doesn't.\"\n    row-gap: 28px;\n    align-items: flex-start;\n    margin-top: 20px;\n}\n\n.setting-group {\n    flex: 1 1 280px;\n    max-width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    // Deliberately tighter than setting-groups' row-gap (28px): rows within a group cluster\n    // together, reinforcing that they're one unit rather than an accident of field spacing.\n    gap: 4px;\n}\n\n.setting-group-label {\n    margin: 0 0 12px;\n    font-size: 14px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    opacity: 0.7;\n}\n\n.setting {\n    display: flex;\n    align-items: center;\n}\n\n.override-toggle {\n    // Fixed width so every checkbox across every row/group lands on the same vertical line --\n    // continuity reads it as a single \"toggle\" column independent of label length or datatype.\n    flex: 0 0 32px;\n}\n\n.form-fields {\n    width: 90%;\n    margin-top: 0px;\n    margin-left: 15px;\n    margin-right: 15px;\n    margin-bottom: -5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
